import React, { ChangeEvent } from 'react'
import "./ModalPreviewEmail.css"
import ConfirmButton from '../../../../UIcomponents/Modals/ConfirmButton/ConfirmButton'
import { useTranslation } from 'react-i18next'
import { PreviewEmail } from '../../ConModalResumeScheduleEmail/ModalResumeScheduleNotification/ModalResumeScheduleEmail'

const limitWidthCellphone = 700


const getBlockGimGimmerLogo = (forGim: boolean) => {
    return {
        html: `
            <div class="general-con" style="background-color:${forGim ? "#6290C3" : "#E54B4B"};padding-top: 40px; padding-bottom: 40px;">

                <div style="text-align: center;">
                    <img style="width: 200px;" src="https://public-gimwork.s3.us-west-1.amazonaws.com//images/gimwork_white.png" />
                </div>

            </div>
        `,
        css: `

        `
    }
}

const getRequestBlock = (bodyEmail: string, forGim: boolean) => {
 
    return {
        html: `
            <div class="general-con" style="padding-top: 30px; padding-bottom: 0px; display: inline-block;">

                <p style="color: #394153;" class="text-title" >Hola Usuario,</p>


                <p class="description"> 
                    ${bodyEmail}
                </p>


            </div>
        `,
        css: `
            .text-title{
                font-size: 18px;
                text-align: start;
                color: #394153;
            }
            .description{
                margin-top: 20px;
                margin-bottom: 20px;
                text-align: start;
                color: #394153;
                font-size: 14px;
            }


            @media (min-width: 0px) and (max-width: 699px) {

            }

            
            @media (min-width: ${limitWidthCellphone}px) {
                .description{
                    margin-top: 30px;
                    font-size: 18px;
                }
                .title-list{
                    margin-top: 30px;
                    font-size: 20px;
                    text-align: start;
                }
            }
        `
    }
}

const getChellphoneDownloadButtons = (forGim: boolean) => {

     
    return {
        html: `
        
            <div class="img-bg-gimwork general-con">
                    
                <img class="img-cell img-cell-1" src="https://public-gimwork.s3.us-west-1.amazonaws.com//images/cellphone_gim.png" />

                <div style="" class="con-text-btns-stores">

                    <table width="100%" height="100%;" border="0" cellspacing="0" cellpadding="0">
                        <tr>
                            <td width="100%" align="center" valign="center" style="font-family:Arial, Helvetica, sans-serif; font-size:2px; color:#ffffff;">
                                <div class="con-buttons-text">

                                    <p class="item-tutorial" style="color: white;font-size: 24px;">👉Descargar App</p>
            
            
            
                                    <p class="text-cellphone" style="color: white; font-size: 20px; margin-bottom: 26px; margin-top: 20px;">
                                        Es fácil, rápido y te ayudará a estar siempre conectado con tus clientes.
                                    </p>
            
            
                                    <div style="text-align: center;" class="store-btns">
                                        <a target="_blank" style="display: block;" href="https://play.google.com/store/apps/details?id=com.gwcore.gimwork">
                                            <img style="width: 38vw;" class="google-img" src="https://public-gimwork.s3.us-west-1.amazonaws.com//images/google.png" />
                                        </a>
                                        <a target="_blank" style="display: block;" href="https://apps.apple.com/mx/app/gimwork/id6450014304">
                                            <img style="width: 40vw;" class="apple-img-main apple-img" src="https://public-gimwork.s3.us-west-1.amazonaws.com//images/apple_2.png" />
                                        </a>
                                    </div>
            
                                    <div class="store-btns-desk">
                                        <a target="_blank" href="https://play.google.com/store/apps/details?id=com.gwcore.gimwork">
                                            <img style="width: 140px;" src="https://public-gimwork.s3.us-west-1.amazonaws.com//images/google.png" />
                                        </a>
                                        <a target="_blank" href="https://apps.apple.com/mx/app/gimwork/id6450014304">
                                            <img style="width: 140px;" class="apple-img-main" src="https://public-gimwork.s3.us-west-1.amazonaws.com//images/apple_2.png" />
                                        </a>
                                    </div>
            
                                    <img class="img-cell img-cell-2" src="https://public-gimwork.s3.us-west-1.amazonaws.com//images/cellphone_gim.png" />
            
                 
                                    <div class="btn-tutorial">
                                        <a target="_blank" href="https://www.youtube.com/watch?v=DMRuJih1RQo" style="cursor: pointer;">
                                            <button style="font-size: 15px; background-color: white; height: 36px; padding-left: 46px; padding-right: 46px; outline: none; border: none; margin-top: 30px; border-radius: 3px; cursor: pointer; color: ${forGim ? "#6290C3" : "#E54B4B"}">
                                                Mira el tutorial aquí
                                            </button>
                                        </a>
                                    </div>

            
                                </div>
                            </td>
                        </tr>
                    </table>

                </div>

            </div>
        `,
        css: `
            .img-bg-gimwork{
                background-image: url("https://public-gimwork.s3.us-west-1.amazonaws.com//images/logo-W-gimwork-white.png");
                width: 100%;
                background-color:${forGim ? "#6290C3" : "#E54B4B"};
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
                position: relative;
                padding-bottom: 15px;
            }

            .img-cell{
                margin-top: 15px;
                width: 50%;
                margin-left: 0;
                left: 0;
            }

            .img-cell-1{
                width: 0;
                height: 0;
            }

            .img-cell-2{

            }

            .con-buttons-text{
                text-align: center;
            }

            .con-text-btns-stores{
                text-align: center;
                margin: 0 auto;
            }

            .text-cellphone{
                text-align: center;
            }

            .store-btns{
                display: block;
            }

            .store-btns-desk{
                display: none;
            }

            .store-img{
                width: 30vw;
                height: calc(30vw * 0.3217);
            }
            
            .google-img{
            }

            .apple-img{
                margin-top: 10px;
            }

            .apple-img-main{
                margin-left: 0px;
            }

            .item-tutorial{
                text-align: center;
            }

            .btn-tutorial{
                text-align: center;
                cursor: pointer;
            }

            @media (min-width: 700px) {
                .img-bg-gimwork{
                    width: 100%;
                    height: 310px; 
                    background-size: contain;
                }
    
                .img-cell{  
                    position: absolute;              
                    width: 170px;
                    height: 340px;
                    margin-left: 0;
                    margin-top: 30px;
                }

                .img-cell-1{
                    
                }
    
                .img-cell-2{
                    width: 0;
                    height: 0;
                }

                .con-buttons-text{
                    text-align: start;
                }
    
                .con-text-btns-stores{
                    float: right; 
                    vertical-align: middle;
                    height: 100%;
                    width: 60%;
                    position: relative;
                }

                .text-cellphone{
                    text-align: start;
                }
    
                .google-img{
                    float: left;
                }
    
                .apple-img{
                    float: right;
                    margin-top: 0px;
                }

                .apple-img-main{
                    margin-left: 20px;
                }

                .store-img{
                    width: 140px;
                    height: calc(140px * 0.3217);
                }

                .store-btns{
                    display: none;
                }

                .store-btns-desk{
                    display: inline-block;
                }

                .item-tutorial{
                    text-align: start;
                }

                .btn-tutorial{
                    text-align: start;
                    
                }
            }
        `
    }
}

const getText8 = () => {
    return {
        html: `
            <div class="general-con" style="font-size: 19px; padding-top: 40px; padding-bottom: 40px; color: #3A4153;">
                <p style="color: #3A4153;" class="text-4 text-cl"> Nos pondremos en contacto contigo en breve. ¡Gracias por elegir Gimwork! </p>

                <p style="margin-top: 25px; color: #3A4153;" class="text-cl"> Saludos, </p>
                <p style="color: #3A4153;" class="text-cl"> El equipo de Gimwork </p>

            </div>
        `,
        css: `
            .text-4{
                margin-top: 14px;
            }  

            .text-cl{
                text-align: center;
            }

            @media (min-width: 700px) {
                .text-4{
                    margin-top: 70px;
                }

                .text-cl{
                    text-align: start;
                }
            }
        `
    }
}


type ModalPreviewEmailProps = {
    subject: string
    bodyEmail: string
    previewEmail: PreviewEmail
    onSubmit: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
    onCloseModal: () => void
}

const ModalPreviewEmail = ({
    subject,
    bodyEmail,
    previewEmail,
    onSubmit,
    onCloseModal,
}: ModalPreviewEmailProps) => {

    const { t } = useTranslation()

    const forGim = true

    const html = `
        <head>
            <style>
                * {
                    padding:0;margin:0;
                }
                * {
                    box-sizing: border-box;
                    margin: 0;
                    padding: 0;
                }

                a {
                    text-decoration:none
                }

                th > a {
                    color: white;
                    font-weight: 100;
                }

                .center{
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    height: 100%;
                }

                .main-con{
                    font-size: 12px;
                    width: 100%;
                    position: relative;
                }

                .general-con {
                    padding-left: 15px;
                    padding-right: 15px;
                    width: 100%;
                    border-radius: 2px;
                }

                @media (min-width: 700px) {
                    .main-con{
                        font-size: 20px;
                        width: 100%;
                        margin: 0 auto;
                    }

                    .general-con {
                        padding-left: 70px;
                        padding-right: 70px;
                        width: 100%;
                        max-width: 1200px;
                    }
                }

                ${getBlockGimGimmerLogo(forGim).css}
                ${getRequestBlock(bodyEmail, forGim).css}
                ${getChellphoneDownloadButtons(forGim).css}
                ${getText8().css}

            </style>
        </head>

        <body>

            <table width="100%" height="100%;" border="0" cellspacing="0" cellpadding="0" class="main-con">
                <tr>
                    <td width="100%" align="center" valign="center">
                        <div>

                            ${getBlockGimGimmerLogo(forGim).html}
                            ${getRequestBlock(bodyEmail, forGim).html}
                            ${getChellphoneDownloadButtons(forGim).html}
                            ${getText8().html}




                        </div>
                    </td>
                </tr>
            </table>

        </body>
    `

    return (
        <div className="modal-schedule-email-preview flex flex-d-column" style={{ width: previewEmail === "Desktop" ? "95vw" : "68rem" }}>

            <div className="flex-1 center">
                <iframe
                    title="preview"
                    srcDoc={html}
                    style={{
                    width: previewEmail === "Desktop" ? "100%" : "50%",
                    height: "100%",
                    border: "1px solid #ccc",
                    }}
                    sandbox="allow-scripts"
                />
            </div>

            <form onSubmit={onSubmit} className="flex flex-d-column flex-jc-end mt-20">

                <div className="flex flex-jc-sb">
                    <button
                        onClick={onCloseModal}
                        className="cancel-btn-resume-notif"
                    >
                        {t("Emails:schedule:index:label_19")}
                    </button>
                    <ConfirmButton text={t("General:label_131")} width="18rem" />
                </div>

            </form>
            
        </div>
    )
}

export default React.memo( ModalPreviewEmail )